import { createFileRoute, notFound } from "@tanstack/react-router";
import kitStyles from "../styles/ui-kit.css?url";
import { UiGallery } from "../components/previews/ui-gallery";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadUiKit } from "../server/previews";

/** The site UI kit gallery (/preview/ui), on development servers only. */
export const Route = createFileRoute("/preview/ui")({
  loader: async () => {
    const kit = await loadUiKit();
    if (!kit) throw notFound();
    return kit;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/preview/ui",
        title: `UI kit | ${loaderData.creatorName}`,
        description: shell.creator.description,
        noindex: true,
      }),
      kitStyles,
    );
  },
  component: UiGallery,
});
